// extracted by mini-css-extract-plugin
export default {"wrapper":"main-05_wrapper__ZpqQB","container":"main-05_container__i431v","boxCard":"main-05_boxCard__L2EYb"};